// extracted by mini-css-extract-plugin
export var standaloneTable = "_f8-0";
export var standaloneTableWithBodyFill = "_f8-1";
export var withExtraHeader = "_f8-2";